import React from 'react';
import { connect } from 'react-redux';
import { DBSpecDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecialTestCoordinationAsiodochokinesis extends React.Component {

    render() {
        return (
            <div key={this.props.panelId} className={styles.dropdown_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Special Test - Coordination - Diadochokinesis' />
                <span className={styles.spacer} />
                <label className={styles.label}>Diadochokinesis</label>
                <DBSpecDropDownObjective
                    field='TSCOORASIODOOPEN'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.r}
                    optionsValue={1}
                />
                <span className={styles.c} />
                <DBSpecDropDownObjective
                    field='TSCOORASIODOCLOSED'
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.l}
                    optionsValue={1}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCOORASIODOOPEN === 'positive' ||
            state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSCOORASIODOCLOSED === 'positive'
            ? true : false,
    };
}

const connectedSpecialTestCoordinationAsiodochokinesis = connect(mapStateToProps)(SpecialTestCoordinationAsiodochokinesis);
export { connectedSpecialTestCoordinationAsiodochokinesis as SpecialTestCoordinationAsiodochokinesis };
